/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./addProduct.vue?vue&type=template&id=393706fa&scoped=true&"
import script from "./addProduct.vue?vue&type=script&lang=js&"
export * from "./addProduct.vue?vue&type=script&lang=js&"
import style0 from "./addProduct.vue?vue&type=style&index=0&id=393706fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393706fa",
  null
  
)

export default component.exports